import styled from '@emotion/styled';
import { Button as RawButton } from '@hotjar/hotsauce';

export const Button = styled(RawButton)`
  justify-content: center;
`;
